/* eslint-disable */
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Dissatisfied from "@material-ui/icons/SentimentVeryDissatisfied";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Footer from "components/layout/Footer";
import Spinner from "components/layout/spinners/Index";
import AllowancesContext from "context/allowance/allowanceContext";
import InventoryContext from "context/inventory/inventoryContext";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { animated, useTransition } from "react-spring";
import { useStyles } from "../../../components/layout/CommonStyles";
import MySnackbarContentWrapper from "../../../components/layout/Message";
import RequestsTable from "./RequestsTable";
import { Link } from "react-router-dom";
import { GetGeneralPermissionForAction } from "utils/permissions/GetGeneralPermissionForAction";
import { Screen, Allow } from "global/constants";

const MyRequests = props => {
  const classes = useStyles();
  const [t] = useTranslation();
  const inventoryContext = useContext(InventoryContext);
  const allowanceContext = useContext(AllowancesContext);

  const [snackBar, setSnackBar] = useState({
    open: false,
    kind: "",
    content: "",
  });

  const [findText, setFindText] = useState("");
  const [filterName, setFilterName] = useState("");
  const [filterRequisitionType, setFilterRequisitionType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  const [filterCode, setFilterCode] = useState("");
  const [filterKey, setFilterKey] = useState("");
  const [filterPlatform, setFilterPlatform] = useState("");
  const [filterDateCreated, setFilterDateCreated] = useState(null);
  const [filterActivationDate, setFilterActivationDate] = useState("");
  const [filterValitidy, setFilterValitidy] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterResponsible, setFilterResponsible] = useState("");
  const [filterMachine, setFilterMachine] = useState("");
  const [dataFilter, setDataFilter] = useState([]);

  if (localStorage.getItem("auth-token") !== null) {
    var auth = JSON.parse(localStorage.getItem("auth-token"));
  }

  const status = [
    "Aguardando Aprovação",
    "Aguardando Execução",
    "Executada",
    "Recusada",
  ];
  const requestType = [
    "Todas",
    "Devolução de Equipamento",
    "Utilização de Equipamento",
    "Utilização de Software",
    "Alteração de Local",
    "Devolução de Software",
  ];

  const {
    loadingSoftware,
    response,
    hasChanged,
    setHasChanged,
    responseType,
    successiveActions,
    getMyRequests,
    myRequests,
  } = inventoryContext;

  const {
    allowanceResponse,
    allowanceResponseType,
    messageHasChanged,
    resetAllowanceMessage,
    permission,
  } = allowanceContext;

  useEffect(() => {
    if (myRequests && myRequests.length) {
      const { newDataFilter, textNoFound } = applyFilter(myRequests);

      if (newDataFilter.length === 0) {
        setDataFilter([]);
        setHasNoResult(true);
        setFindText(textNoFound);
      } else {
        setDataFilter(newDataFilter);
        setHasNoResult(false);
        setFindText("");
      }
    }
  }, [
    myRequests,
    filterCode,
    filterKey,
    filterResponsible,
    filterActivationDate,
    filterPlatform,
    filterName,
    filterRequisitionType,
    filterStatus,
    filterDateCreated,
    filterMachine,
    filterType,
    filterValitidy,
  ]);

  const applyFilter = Requests => {
    let newDataFilter = [];
    let textNoFound = "";

    newDataFilter = Requests;

    if (
      filterRequisitionType &&
      filterRequisitionType.toLowerCase() !== "todas"
    ) {
      newDataFilter = newDataFilter.filter(
        item =>
          item.class &&
          item.class.toLowerCase() === filterRequisitionType.toLowerCase()
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterRequisitionType;
    }

    if (filterStatus) {
      newDataFilter = newDataFilter.filter(
        item =>
          item.status &&
          item.status.toLowerCase() === filterStatus.toLowerCase()
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterStatus;
    }

    if (filterDateCreated && dateToBR(filterDateCreated).length === 10) {
      newDataFilter = newDataFilter.filter(
        item =>
          item.dateCreated &&
          item.dateCreated.startsWith(dateToBR(filterDateCreated))
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = dateToBR(filterDateCreated);
    }

    return { newDataFilter, textNoFound };
  };

  const hasItens = myRequests.length > 0;
  const [hasNoResult, setHasNoResult] = useState(
    hasItens && dataFilter.length === 0
  );

  const transitions = useTransition(loadingSoftware, null, {
    from: { opacity: 0 },
    enter: {
      opacity: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "calc(100vh - 70px)",
    },
    leave: { opacity: 0 },
  });

  useEffect(() => {
    getMyRequests(auth.id);

    if (allowanceResponseType === "ERROR" && messageHasChanged) {
      handleSnack({ kind: "error", content: allowanceResponse });
    }
    if (responseType === "SUCCESS" && hasChanged > successiveActions) {
      handleSnack({ kind: "success", content: response });
    }
    if (responseType === "ERROR" && hasChanged > successiveActions) {
      handleSnack({ kind: "error", content: response });
    }

    return () => {};
  }, [
    responseType,
    response,
    successiveActions,
    allowanceResponseType,
    allowanceResponse,
    permission.length,
    myRequests.length,
  ]);

  const handleSnack = () => {
    setSnackBar({ ...snackBar, open: true });
    setHasChanged();
  };
  const handleSnackClose = () => {
    setSnackBar({ ...snackBar, open: false });
    resetAllowanceMessage();
  };

  function dateToBR(date) {
    var data = new Date(date),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }

  return transitions.map(({ item, key, props }) => (
    <React.Fragment>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackBar.open}
        onClose={handleSnackClose}
        TransitionComponent={Slide}
        transitionDuration={{ enter: 500, exit: 500 }}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        autoHideDuration={2000}
      >
        <MySnackbarContentWrapper
          onClose={handleSnackClose}
          variant={
            responseType !== ""
              ? responseType.toLowerCase()
              : allowanceResponseType.toLowerCase()
          }
          message={
            <span id="message-id">
              {response !== "" ? response : allowanceResponse}
            </span>
          }
        />
      </Snackbar>
      <div className="container">
        <Breadcrumbs
          className={classes.breadCrumbs}
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <Typography>{t("INVENTORY.inventory")}</Typography>
          <Typography>{t("INVENTORY.myRequests")}</Typography>
        </Breadcrumbs>
        <div className={classes.containerHeader}>
          <div className="title">
            <h1 className={classes.title}>{t("INVENTORY.myRequests")}</h1>
          </div>
          {GetGeneralPermissionForAction(
            Screen.MY_REQUISITIONS,
            Allow.CREATE
          ) && (
            <Link to={"/Requisition/new"}>
              <Button
                className={classes.blueButton}
                variant="contained"
                color="primary"
              >
                {t("INVENTORY.add")}
              </Button>
            </Link>
          )}
        </div>
        <Paper>
          <div className="cabecalho">
            {t("INVENTORY.myRequests").toUpperCase()}
          </div>
          {item ? (
            <animated.div key={key} style={props}>
              <Spinner />;
            </animated.div>
          ) : (
            <React.Fragment>
              <div className={classes.divAddParticipantLeft}>
                <Toolbar className={classes.searchToolbarInventory}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div
                      style={{ display: !hasItens ? "none" : "" }}
                      className={classes.searchInventory}
                    >
                      <KeyboardDatePicker
                        className={classes.textField}
                        disableToolbar
                        autoOk={true}
                        variant="inline"
                        format="dd/MM/yyyy"
                        id="dateAcquisition"
                        invalidDateMessage=""
                        label={t("INVENTORY.dateRequisition")}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        value={filterDateCreated}
                        onChange={ev => setFilterDateCreated(ev)}
                      />
                    </div>
                  </MuiPickersUtilsProvider>
                </Toolbar>
                <Toolbar className={classes.searchToolbarInventory}>
                  <div
                    style={{ display: !hasItens ? "none" : "" }}
                    className={classes.searchInventory}
                  >
                    <TextField
                      select
                      id="searchcategory"
                      label={t("INVENTORY.requestType")}
                      name="searchcategory"
                      style={{
                        minWidth: "250px",
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 5,
                      }}
                      value={filterRequisitionType}
                      className={classes.textField}
                      onChange={ev => setFilterRequisitionType(ev.target.value)}
                      margin="normal"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputSearch,
                      }}
                      inputProps={{ "aria-label": "search" }}
                    >
                      {requestType.map(type => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Toolbar>
                <Toolbar className={classes.searchToolbarInventory}>
                  <div
                    style={{ display: !hasItens ? "none" : "" }}
                    className={classes.searchInventory}
                  >
                    <TextField
                      select
                      id="searchcategory"
                      label={t("INVENTORY.status")}
                      name="searchcategory"
                      style={{
                        minWidth: "250px",
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 5,
                      }}
                      value={filterStatus}
                      className={classes.textField}
                      onChange={ev => setFilterStatus(ev.target.value)}
                      margin="normal"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputSearch,
                      }}
                      inputProps={{ "aria-label": "search" }}
                    >
                      {status.map(status => (
                        <MenuItem key={status} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </Toolbar>
              </div>
              <RequestsTable
                rows={dataFilter}
                headers={["id", "dateCreated", "class", "status"]}
                visibleHeaders={[
                  "Data da requisição",
                  "Tipo de Requisição",
                  "Status",
                  "",
                ]}
                sortedFields={["dateCreated", "class", "status"]}
                mainField="dateCreated"
                permission={permission}
              />
              {!hasItens && (
                <div className={classes.noParticipantsMessage}>
                  <h2>{t("INVENTORY.noItensMessage")}</h2>
                  <h4>{t("INVENTORY.noItensSubMessage")}</h4>
                </div>
              )}
              {dataFilter.length === 0 && findText && (
                <div className={classes.noParticipantsMessage}>
                  <div>
                    <Dissatisfied className={classes.notFoundIconStyle} />
                  </div>
                  <h2>{t("GENERAL.noResultsFound")}</h2>
                  <h5>{`Sua busca por "${findText}" não retornou resultados.`}</h5>
                </div>
              )}
            </React.Fragment>
          )}
        </Paper>
      </div>
      <Footer />
    </React.Fragment>
  ));
};

export default MyRequests;
